import React, {Component} from 'react';
import CsvExport from '../../../../../../common/img/icons/csv-export.svg';
import {CSVLink} from 'react-csv';

export default class TableControls extends Component {
    render() {
        return (
            <div className="table__info">
                <div className="table__info-controls">
                    <CSVLink data={this.props.csvData} headers={this.props.csvHeaders} filename="sharedCountExport.csv">
                        <button className="hidden-mobile">
                            <img src={CsvExport} alt=""/>
                            <span>Export to CSV</span>
                        </button>
                    </CSVLink>
                    <button onClick={this.props.handleClearTable}>Clear all</button>
                </div>
            </div>
        );
    }
}
